<div class="npdc-title">
  @if (placename) {
    <h1>Edit placename - {{ placename.title }}</h1>
  } @else {
    <h1>New placename</h1>
  }

  <div class="npdc-title__actions">
    @if (form.pristine) {
      <a mat-flat-button type="button" routerLink="/placename/{{ placename?.id }}">Close</a>
    } @else {
      <a mat-button type="button" routerLink="/placename/{{ placename?.id }}">Close</a>
    }
  </div>
</div>

<mat-tab-group animationDuration="0ms" disablePagination="true">
  <mat-tab>
    <ng-template mat-tab-label><mat-icon>info</mat-icon>General </ng-template>

    <form id="form" [formGroup]="form" (ngSubmit)="save()">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Title</mat-label>
          <input matInput formControlName="title" />
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="draft">Draft</mat-option>
            <mat-option value="suggestion">Suggestion</mat-option>
            <mat-option value="official">Official</mat-option>
            <mat-option value="historical">Historical</mat-option>
            <mat-option value="standardised">Standardised</mat-option>
            <mat-option value="other">Other</mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Country</mat-label>
          <mat-select formControlName="country">
            <mat-option value="Argentina">Argentina</mat-option>
            <mat-option value="Australia">Australia</mat-option>
            <mat-option value="Antarctica">Antarctica</mat-option>
            <mat-option value="Belgium">Belgium</mat-option>
            <mat-option value="Chile">Chile</mat-option>
            <mat-option value="Germany">Germany</mat-option>
            <mat-option value="United Kingdom of Great Britain and Northern Ireland"
              >United Kingdom of Great Britain and Northern Ireland</mat-option
            >
            <mat-option value="India">India</mat-option>
            <mat-option value="Japan">Japan</mat-option>
            <mat-option value="Norway">Norway</mat-option>
            <mat-option value="New Zealand">New Zealand</mat-option>
            <mat-option value="Russian Federation">Russian Federation</mat-option>
            <mat-option value="United States of America">United States of America</mat-option>
            <mat-option value="South Africa">South Africa</mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Location</mat-label>
          <input formControlName="geometry" matInput placeholder="Ex. 14.214368, 78.06202, 0" />
          <mat-hint>Longitude, latitude and optionally altitude</mat-hint>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>References</mat-label>
          <mat-chip-grid #chipGrid formControlName="keywords">
            @for (keyword of form.controls['keywords'].value; track keyword) {
              <mat-chip-row (removed)="removeKeyword(keyword)">
                {{ keyword }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              [matChipInputFor]="chipGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addKeyword($event)"
            />
          </mat-chip-grid>
          <mat-hint>Press enter or comma to add individual keywords</mat-hint>
        </mat-form-field>
      </p>

      <h2>Facts</h2>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Area</mat-label>
          <mat-select formControlName="area">
            <mat-option value="Antarktis">Antarktis</mat-option>
            <mat-option value="Arktis">Arktis</mat-option>
            <mat-option value="Bouvetøya">Bouvetøya</mat-option>
            <mat-option value="Dronning Maud Land">Dronning Maud Land</mat-option>
            <mat-option value="Jan Mayen">Jan Mayen</mat-option>
            <mat-option value="Peter I Øy">Peter I Øy</mat-option>
            <mat-option value="Svalbard">Svalbard</mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type">
            <mat-option value="administrativeUnit">Administrative unit</mat-option>
            <mat-option value="building">Building</mat-option>
            <mat-option value="hydrography">Hydrography</mat-option>
            <mat-option value="landcover">Landcover</mat-option>
            <mat-option value="landform">Landform</mat-option>
            <mat-option value="other">Other</mat-option>
            <mat-option value="populatedPlace">Populated place</mat-option>
            <mat-option value="protectedSite">Protected site</mat-option>
            <mat-option value="transportNetwork">Transport network</mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Terrain</mat-label>
          <mat-select formControlName="terrain">
            <mat-option value="adm-inndeling">Administrativ inndeling</mat-option>
            <mat-option value="bakke">Bakke</mat-option>
            <mat-option value="banke">Banke</mat-option>
            <mat-option value="brefall">Brefall</mat-option>
            <mat-option value="brehylle">Brehylle</mat-option>
            <mat-option value="bresenking/botn">Bresenking/botn</mat-option>
            <mat-option value="bresprekk">Bresprekk</mat-option>
            <mat-option value="bukt">Bukt</mat-option>
            <mat-option value="bustad">Bustad</mat-option>
            <mat-option value="bygningar">Bygningar</mat-option>
            <mat-option value="dal">Dal</mat-option>
            <mat-option value="djup">Djup</mat-option>
            <mat-option value="elv">Elv</mat-option>
            <mat-option value="fjell">Fjell</mat-option>
            <mat-option value="fjord">Fjord</mat-option>
            <mat-option value="flyplass">Flyplass</mat-option>
            <mat-option value="foss">Foss</mat-option>
            <mat-option value="fyr">Fyr</mat-option>
            <mat-option value="gammal-buplass">Gammal buplass</mat-option>
            <mat-option value="grotte">Grotte</mat-option>
            <mat-option value="grunne">Grunne</mat-option>
            <mat-option value="gruve">Gruve</mat-option>
            <mat-option value="halvøy">Halvøy</mat-option>
            <mat-option value="hamn">Hamn</mat-option>
            <mat-option value="havområde">Havområde</mat-option>
            <mat-option value="holme">Holme</mat-option>
            <mat-option value="hus">Hus</mat-option>
            <mat-option value="hytte">Hytte</mat-option>
            <mat-option value="isbre">Isbre</mat-option>
            <mat-option value="iskuppel">Iskuppel</mat-option>
            <mat-option value="kjelde">Kjelde</mat-option>
            <mat-option value="krater">Krater</mat-option>
            <mat-option value="kyrkje">Kyrkje</mat-option>
            <mat-option value="kyst">Kyst</mat-option>
            <mat-option value="landskapsområde">Landskapsområde</mat-option>
            <mat-option value="lavastraum">Lavastraum</mat-option>
            <mat-option value="li">Li</mat-option>
            <mat-option value="meteorologisk-stasjon">Meteorologisk stasjon</mat-option>
            <mat-option value="monument">Monument</mat-option>
            <mat-option value="nes">Nes</mat-option>
            <mat-option value="område/distrikt">Område/distrikt</mat-option>
            <mat-option value="os">Os</mat-option>
            <mat-option value="pass">Pass</mat-option>
            <mat-option value="renne">Renne</mat-option>
            <mat-option value="rygg-i-sjø">Rygg i sjø</mat-option>
            <mat-option value="sand">Sand</mat-option>
            <mat-option value="skar">Skar</mat-option>
            <mat-option value="slette/vidde">Slette/vidde</mat-option>
            <mat-option value="stadnamn">Stadnamn</mat-option>
            <mat-option value="stasjon">Stasjon</mat-option>
            <mat-option value="stein">Stein</mat-option>
            <mat-option value="strand">Strand</mat-option>
            <mat-option value="straum">Straum</mat-option>
            <mat-option value="stup">Stup</mat-option>
            <mat-option value="sund">Sund</mat-option>
            <mat-option value="undersjøisk-objekt">Undersjøisk objekt</mat-option>
            <mat-option value="ur">Ur</mat-option>
            <mat-option value="utmål">Utmål</mat-option>
            <mat-option value="varde">Varde</mat-option>
            <mat-option value="vatn">Vatn</mat-option>
            <mat-option value="veg">Veg</mat-option>
            <mat-option value="verneområde">Verneområde</mat-option>
            <mat-option value="vik">Vik</mat-option>
            <mat-option value="øy">Øy</mat-option>
            <mat-option value="øygruppe">Øygruppe</mat-option>
            <mat-option value="ås">Ås</mat-option>
            <mat-option value="ruin">Ruin</mat-option>
            <mat-option value="morene">Morene</mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Authority</mat-label>
          <mat-select formControlName="authority">
            <mat-option value="Argentina">Argentina</mat-option>
            <mat-option value="Australia">Australia</mat-option>
            <mat-option value="Antarctica">Antarctica</mat-option>
            <mat-option value="Belgium">Belgium</mat-option>
            <mat-option value="Chile">Chile</mat-option>
            <mat-option value="Germany">Germany</mat-option>
            <mat-option value="United Kingdom of Great Britain and Northern Ireland"
              >United Kingdom of Great Britain and Northern Ireland</mat-option
            >
            <mat-option value="India">India</mat-option>
            <mat-option value="Japan">Japan</mat-option>
            <mat-option value="Norway">Norway</mat-option>
            <mat-option value="New Zealand">New Zealand</mat-option>
            <mat-option value="Russian Federation">Russian Federation</mat-option>
            <mat-option value="United States of America">United States of America</mat-option>
            <mat-option value="South Africa">South Africa</mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <h2>History</h2>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Start</mat-label>
          <input
            formControlName="start"
            matInput
            type="number"
            placeholder="YYYY"
            min="0"
            max="9999"
          />
          <mat-hint>Lifespan start (year)</mat-hint>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>End</mat-label>
          <input
            formControlName="end"
            matInput
            type="number"
            placeholder="YYYY"
            min="0"
            max="9999"
          />
          <mat-hint>Lifespan end (year)</mat-hint>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Proposer</mat-label>
          <input formControlName="proposer" matInput />
        </mat-form-field>
      </p>

      <h2>Description</h2>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <textarea formControlName="description" matInput rows="12"></textarea>
          <mat-hint
            >Keywords surrounded by [square brackets] will be replaced by links to
            placenames.</mat-hint
          >
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Origin</mat-label>
          <textarea formControlName="origin" matInput rows="6"></textarea>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Comment</mat-label>
          <textarea formControlName="comment" matInput rows="3"></textarea>
        </mat-form-field>
      </p>

      <p class="npdc-form-actions">
        <button mat-flat-button type="submit" [disabled]="form.pristine || form.invalid">
          Save
        </button>
      </p>
    </form>
  </mat-tab>
  <mat-tab [disabled]="!this.placename">
    <ng-template mat-tab-label>
      <mat-icon>folder_open</mat-icon>
      Cases
    </ng-template>
    <p>
      <button mat-flat-button (click)="addCase()">Add</button>
      @if (caseList.selectedOptions.selected.length; as length) {
        <button mat-button (click)="removeCases(caseList.selectedOptions.selected)">Remove</button>
      }
    </p>
    <app-list [resource]="cases" [disableClear]="true">
      <mat-selection-list #caseList>
        @if (!cases.error()) {
          @for (c of cases.value()?.items; track c.id) {
            <mat-list-option togglePosition="before" [value]="c.id">
              <span matListItemTitle>{{ c.title }}</span>
              <span matListItemLine>{{ c.area || 'N/A' }}, {{ c.date | date: 'yyyy' }}</span>
              <span matListItemLine>Case {{ c.number || 'N/A' }}</span>
            </mat-list-option>
          }
        }
      </mat-selection-list>

      @if (!cases.error()) {
        <mat-paginator
          showFirstLastButtons
          (page)="casesPage.set($event.pageIndex)"
          [length]="cases.value()?.count"
          [pageIndex]="casesPage()"
          [hidePageSize]="true"
        >
        </mat-paginator>
      }
    </app-list>
  </mat-tab>
  <mat-tab [disabled]="!this.placename">
    <ng-template mat-tab-label>
      <mat-icon>location_on</mat-icon>
      Alternatives
    </ng-template>
    <p>
      <button mat-flat-button (click)="addSameAs()">Add</button>
      @if (alternativeList.selectedOptions.selected.length; as length) {
        <button mat-button (click)="removeSameAs(alternativeList.selectedOptions.selected)">
          Remove
        </button>
      }
    </p>
    <app-list [resource]="alternative" [disableClear]="true">
      <mat-selection-list #alternativeList>
        @if (!alternative.error()) {
          @for (p of alternative.value()?.items; track p.id) {
            <mat-list-option togglePosition="before" [value]="p.id">
              <span matListItemTitle>{{ p.title }}</span>
              <span matListItemLine>{{ p.area || 'N/A' }}, {{ p.start }}</span>
              <span matListItemLine>{{ p.keywords.join(', ') }}</span>
            </mat-list-option>
          }
        }
      </mat-selection-list>

      @if (!alternative.error()) {
        <mat-paginator
          showFirstLastButtons
          (page)="alternativePage.set($event.pageIndex)"
          [length]="alternative.value()?.count"
          [pageIndex]="alternativePage()"
          [hidePageSize]="true"
        >
        </mat-paginator>
      }
    </app-list>
  </mat-tab>
  <mat-tab [disabled]="!this.placename">
    <ng-template mat-tab-label>
      <mat-icon>location_on</mat-icon>
      Replaces
    </ng-template>
    <p>
      <button mat-flat-button (click)="addReplacement()">Add</button>
      @if (replacementsList.selectedOptions.selected.length; as length) {
        <button mat-button (click)="removeReplacements(replacementsList.selectedOptions.selected)">
          Remove
        </button>
      }
    </p>
    <app-list [resource]="replacements" [disableClear]="true">
      <mat-selection-list #replacementsList>
        @if (!replacements.error()) {
          @for (p of replacements.value()?.items; track p.id) {
            <mat-list-option togglePosition="before" [value]="p.id">
              <span matListItemTitle>{{ p.title }}</span>
              <span matListItemLine>{{ p.area || 'N/A' }}, {{ p.start }}</span>
              <span matListItemLine>{{ p.keywords.join(', ') }}</span>
            </mat-list-option>
          }
        }
      </mat-selection-list>

      @if (!replacements.error()) {
        <mat-paginator
          showFirstLastButtons
          (page)="replacementsPage.set($event.pageIndex)"
          [length]="replacements.value()?.count"
          [pageIndex]="replacementsPage()"
          [hidePageSize]="true"
        >
        </mat-paginator>
      }
    </app-list>
  </mat-tab>
</mat-tab-group>
